module.exports = __webpack_public_path__ + "img/lingqu.0a9640f9.png";